import {sItemIntToKey} from '../../models-old/datastructures';
import {IStore} from '../../../shared/shared-models/store/store';
import {StockPack, StockPackItem} from '../../models-old/stock/stock-pack';
import {DocumentData} from '@angular/fire/firestore';

/**
 * @class ObjectUtils
 * Utilities for manipulating and displaying numbers.
 *
 * @member deleteNonObjectProperties Delete properties not related to an object model / interface.
 * @member castObject Delete properties not related to an object model / interface.
 * @member objectify Objectify a DocumentDataItem for a given store.
 */
export class ObjectUtils {

  /**
   * Delete properties not related to an object model / interface.
   *
   * @param initialObject The object whose properties needs to be checked.
   * @param resultObjectModel Cast an object using item integers to keys.
   */
  static deleteNonObjectProperties<ResultModel, InitialModel extends object>(initialObject: InitialModel, resultObjectModel: ResultModel): ResultModel {
    const result: ResultModel = {} as ResultModel;
    Object.keys(resultObjectModel).forEach((key: string): void => {
      if (key in initialObject) {
        result[key] = initialObject[key];
      } else {
        switch (typeof resultObjectModel[key]) {
          case 'string':
            result[key] = '';
            break;
          case 'boolean':
            result[key] = false;
            break;
        }
      }
    });
    return result;
  }

  // static castObject<CastType>(castObject: any, store?: IStore): CastType {
  //   const newObject: CastType = store
  //     ? {storeId: store.storeId, store: store.name} as CastType
  //     : {} as CastType;
  //   Object.keys(castObject)
  //     .forEach((key: string): void => {
  //       newObject[sItemIntToKey[key]] = castObject[key];
  //     });
  //   return newObject;
  // }

  // static objectify<CastType>(isCasting: boolean, next: DocumentData[], idField: string, store: IStore): any[] {
  //   let stockPack: StockPack | StockPackItem = {} as StockPack | StockPackItem;
  //   if (isCasting) {
  //     stockPack.ids = next.map((rawItem: DocumentData) => {
  //       stockPack.items[rawItem[idField]] = this.castObject<CastType>(rawItem, store);
  //       return rawItem[idField];
  //     });
  //   } else {
  //     stockPack = {ids: [], items: {}};
  //     stockPack.ids = next.map((rawItem: DocumentData) => {
  //       stockPack.items[rawItem[idField]] = this.castObject<CastType>(rawItem, store);
  //       return rawItem[idField];
  //     });
  //   }
  //   return [stockPack];
  // }

  static castObject<CastType extends Record<string, unknown>>(
    castObject: Record<string, unknown>,
    store?: IStore
  ): CastType {
    const newObject: CastType = store
      ? {storeId: store.storeId, store: store.name} as unknown as CastType
      : {} as CastType;
    Object.keys(castObject).forEach((key: string): void => {
      const mappedKey = sItemIntToKey[key];
      if (mappedKey) {
        (newObject as Record<string, unknown>)[mappedKey] = castObject[key];
      }
    });

    return newObject;
  }

  static objectify<CastType extends Record<string, unknown>>(
    isCasting: boolean,
    next: DocumentData[],
    idField: string,
    store: IStore
  ): (StockPack | StockPackItem)[] {
    const stockPack: StockPack | StockPackItem = {
      ids: [],
      items: {}
    } as StockPack | StockPackItem;

    stockPack.ids = next.map((rawItem: DocumentData) => {
      const id = rawItem[idField];
      stockPack.items[id] = this.castObject<CastType>(rawItem, store);
      return id;
    });

    return [stockPack];
  }

}

